<template>
    <div id="Veriface">
        <div class="box">
            <span>录制一段自己朗读如下数字的视频</span>
        </div>
        <div class="appear">
            <div class="text">
                <span>请使用<br />前置摄像头</span>
                <span>请用普通话<br />读一遍</span>
                <span>视频时长<br />3~6秒</span>
            </div>
            <div class="progress">
                <img src="./dot.png" alt="" />
                <span></span>
                <img src="./dot.png" alt="" />
                <span></span>

                <img src="./dot.png" alt="" />
            </div>
            <div class="figure">{{ randomNum }}</div>
        </div>
        <div class="btn" :class="{ nouse: !faceValiateTimeRes }">
            <form
                :action="uploadUrl"
                method="post"
                enctype="multipart/form-data"
                ref="form"
                id="form"
            >
                <input
                    type="file"
                    accept="video/*"
                    capture="user"
                    name="file"
                    id="faceInput"
                    style="display: none;"
                    v-on:change="upload"
                />
                <input type="hidden" name="actionType" value="RELATE" />
                <input type="hidden" name="sign" v-model="sign" />
                <input type="hidden" name="isInsured" value="0" />
                <div style="text-align: center;">
                    <label class="button" v-if="!faceValiateTimeRes"
                        >超过5次</label
                    >
                    <label class="button" for="faceInput" v-else
                        >开始识别</label
                    >
                </div>
            </form>
        </div>
        <div class="popup" @click="hidePopup" v-show="showPopupFlag">
            <span class="tip_pop"></span>
            <span class="text_tip" ref="popup_text"></span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapMutations } from "vuex";
import { Toast } from "vant";
Vue.use(Toast);

import http from "../../h5-network/request.js";
import upload from "../../h5-network/upload.js";
import qs from "qs";
const url = qs.parse(window.location.search.slice(1));

export default {
    data() {
        return {
            appTitle: "人脸识别绑定",
            uploadUrl: "/bdzb-core-service/member/validateVideo",
            uploadingFlag: false,
            showPopupFlag: false,
            sign: "",
            randomNum: "",
            bindAgainParam: "",
            faceValiateTimeRes: true,
        };
    },
    created() {
        let bindAgainParam = window.sessionStorage.getItem("bindAgainParam");
        if (bindAgainParam) {
            this.bindAgainParam = JSON.parse(bindAgainParam);
            this.getRandomNum();
            this.setDataForAgain(this.bindAgainParam);
        }
    },
    methods: {
        ...mapMutations({
            isRelateInsurance: "isRelateInsurance",
        }),
        popup(txt) {
            this.$refs.popup_text.innerHTML = txt;
            this.showPopupFlag = true;
        },
        hidePopup() {
            this.showPopupFlag = false;
            document.getElementById("faceInput").value = "";
            this.getRandomNum();
        },
        getRandomNum() {
            //获取随机数
            var bindAgainParam = this.bindAgainParam;

            http({
                loading: true,
                url: "/bdzb-core-service/far/getBindingPolicyRandom",
                data: {
                    name: bindAgainParam.userName,
                    icNumber: bindAgainParam.cardNo,
                },
                method: "POST",
            })
                .then((data) => {
                    if (data) {
                        this.randomNum = data.random_number;
                        this.sign = data.sign;
                        //返回validateStatus为false表示次数超过5次了
                        if (data.validateStatus == "false") {
                            this.faceValiateTimeRes = false;
                        }
                    }
                })
                .catch((err) => {});
        },
        upload(source) {
            var file = source.currentTarget.files[0];
            if (file.size == 0 || file.type.indexOf("video") == -1) {
                this.popup("文件异常，可能您的手机或浏览器不支持此项功能");
                return false;
            }
            this.popup("上传中");
            var size = file.size / 1024 / 1024;
            if (size > 20) {
                this.popup("拍摄的视频过大，请重试");
                return false;
            }

            var self = this;
            this.uploadingFlag = true;
            var uploadParam = new FormData();
            uploadParam.append("file", file);
            uploadParam.append("actionType", "RELATE");
            uploadParam.append("sign", this.sign);
            uploadParam.append("isInsured", "0");
            upload({
                loading: true,
                url: this.uploadUrl,
                data: uploadParam,
                method: "POST",
            })
                .then(
                    ({ data }) => {
                        if (data) {
                            data = JSON.parse(data);
                            console.log(data);
                            this.uploadingFlag = false;
                            if (
                                data.respCode == "03" ||
                                data.respCode == "04"
                            ) {
                                //签名失效和其它校验失败
                                self.popup(data.respDesc);
                            } else {
                                self.popup(
                                    data.respData &&
                                        data.respData.result == "true"
                                        ? "验证通过"
                                        : "验证失败"
                                );
                                if (
                                    data.respData &&
                                    data.respData.result == "true"
                                ) {
                                    self.bindInurance();
                                }
                            }
                        }
                    },
                    function(data) {
                        this.uploadingFlag = false;
                        self.popup(data.responseText || "上传失败！");
                    }
                )
                .catch((err) => {
                    this.uploadingFlag = false;
                    self.popup(err.msg || "上传失败！");
                });
        },
        bindInurance() {
            if (url.source == "WX") {
                //微信端

                if (url.type == "1") {
                    this.bindPolicyAndWechatReg();
                } else {
                    this.bindPolicyByWechat();
                }
            } else {
                this.bindPolicyByH5();
            }
        }, //微信保单绑定保单+注册
        bindPolicyAndWechatReg() {
            const self = this;
            let param = {
                smsCode: "" + this.smsCode,
                source: "" + url.source,
                idcard: "" + this.cardNo,
                ucode: "" + this.ucode,
                tcode: "" + this.tcode,
                mobile: "" + this.phone,
                code: url.ma_code,
                action: "" + this.action,
            };

            if (self.isAgainBind) {
                param.hasFace = "Y";
            }
            http({
                loading: true,
                url: "/bdzb-core-service/member/wechat/bindPolicyAndAutoReg",
                data: param,
                method: "POST",
            })
                .then((data) => {
                    let res = data;
                    if (res.respCode == "00") {
                        self.memberCenterBindLogic(res, param);
                    } else {
                        self.bindPolicyFaile(res);
                    }
                })
                .catch((err) => {
                    Toast(err.msg);
                });
        },
        // 微信绑定保单流程
        bindPolicyByWechat() {
            const self = this;
            let param = {
                // todo---  type=2，第一次绑定只要图片验证码(不要输入手机号)。 二次验证只要短信验证码
                // smsCode: "" + this.smsCode,
                source: "" + url.source,
                idcard: "" + this.cardNo,
                ucode: "" + this.ucode,
                tcode: "" + this.tcode,
            };

            if (this.isAgainBind) {
                param.hasFace = "Y";
            }

            http({
                loading: true,
                url: "/bdzb-core-service/member/bindPolicy",
                data: param,
                method: "POST",
            })
                .then((data) => {
                    let res = data;

                    console.log(res, "------res");
                    if (res.respCode == "00") {
                        self.memberCenterBindLogic(res, param);
                    } else {
                        self.bindPolicyFaile(res);
                    }
                })
                .catch((err) => {
                    Toast(err.msg);
                });
        },
        // H5注册+绑定保单流程
        bindPolicyByH5() {
            const self = this;
            let param = {
                mobile: "" + this.phone,
                idcard: "" + this.cardNo,
                smsCode: "" + this.smsCode,
                action: "" + this.action,
                ucode: "" + this.ucode,
                tcode: "" + this.tcode,
            };
            if (this.isAgainBind) {
                param.mobile = this.inputPhone;
                param.hasFace = "Y";
            }
            http({
                loading: true,
                url: "/bdzb-core-service/member/registerBindPolicy",
                data: param,
                method: "POST",
            })
                .then((data) => {
                    let res = data;
                    if (res.respCode == "00") {
                        self.memberCenterBindLogic(res, param);
                    } else {
                        self.bindPolicyFaile(res);
                    }
                })
                .catch((err) => {
                    Toast(err.msg);
                });
        },
        // （微信端+H5）绑定成功后统一处理逻辑【会员中心】
        memberCenterBindLogic(data, param) {
            console.log("memberCenterBindLogic__");
            console.log(JSON.stringify(data));
            if (
                !data.respData ||
                ("errorCode" in data.respData &&
                    data.respData.errorCode != "00")
            ) {
                this.bindPolicyFaile(data);
                return;
            }
            const self = this;
            console.log("self.bindPolicySuccessToBaseInfo");
            //成功，不需要二次验证
            self.bindPolicySuccessToBaseInfo();
        },
        //保单绑定成功并跳转到BaseInfo
        bindPolicySuccessToBaseInfo() {
            //绑定成功的状态
            //window.sessionStorage.setItem("isRelated", "true");
            this.isRelateInsurance({ isRelate: true });
            //Toast("恭喜您、绑定成功");
            this.popup("绑定成功");
            if (url.source != "WX") {
                window.sessionStorage.setItem(
                    "bindPolicyAndRegisterByH5",
                    "yes"
                );
            }

            //next =>
            setTimeout(() => {
                this.$store.dispatch("GET_RELATE_INFO").finally((data) => {
                    if (
                        url.tmrId &&
                        url.origin == "bdzb" &&
                        url.from == "home"
                    ) {
                        //北斗智保小程序首页
                        window.wx.miniProgram.navigateBack();
                    } else {
                        this.$router.go(-1);
                    }
                });
            }, 1000);
        },
        //没找到匹配的保单信息
        bindPolicyFaile(err) {
            if (err.respData && "errorCode" in err.respData) {
                switch (err.respData.errorCode) {
                    case "99":
                        this.popup("系统异常");
                        break;
                    case "66":
                        this.popup("手机号不一致");
                        break;
                    case "06":
                        this.popup("该证件无保单信息");
                        break;
                    case "03":
                        this.popup("该证件号存在多个客户ID");
                        break;
                    case "02":
                        this.popup("预留手机号为空");
                        break;
                    case "01":
                        this.popup("传输的参数不正确");
                        break;
                }
            } else {
                Toast(err.respDesc);
                this.popup(err.respDesc);
            }
        },
        setDataForAgain(param) {
            this.action = param.action;
            this.cardNo = param.cardNo;
            this.phone = param.phone;
            this.systemImgCodeUrl = param.systemImgCodeUrl;
            this.ucode = param.ucode;
            this.tcode = param.tcode;
            this.imgCode = param.imgCode;
            this.smsCode = param.smsCode;
            this.appRegisterPhone = param.appRegisterPhone;
            this.isAgainBind = param.isAgainBind;
            this.source = param.source;
            this.wxType = param.wxType;
            this.isShowCode = param.isShowCode;
            this.inputPhone = param.inputPhone;
            this.mobileList = param.mobileList;
            this.cardType = param.cardType;
            this.userName = param.userName;
        },
    },
};
</script>

<style scoped>
#Veriface {
    height: 100vh;
    font-size: 0.14rem;
}
.header {
    height: 0.4rem;
    font-size: 0.16rem;
    line-height: 0.4rem;
}
.header img {
    width: 0.3rem;
    height: 0.3rem;
    transform: translateY(0.04rem) rotateZ(-180deg);
    margin: 0rem 1rem 0 0.05rem;
}
.box {
    width: 100%;
    height: 55%;
    background: url("./bgperson.png") bottom center no-repeat;
    background-size: 140% 100%;
    position: relative;
}
.box span {
    position: absolute;
    left: 12%;
    top: 0.3rem;
    font-size: 0.18rem;
    color: #fff;
}
.appear {
    margin-top: 0.2rem;
}
.text {
    width: 100%;
    color: #b6b6b6;
}
.text span {
    display: inline-block;
    width: 32%;
    text-align: center;
}

.progress {
    display: flex;
    width: 100%;
    padding: 0 0.45rem;
    box-sizing: border-box;
}
.progress span {
    flex: 1;
    border-bottom: 0.03rem dashed #f2f2f7;
    transform: translateY(-0.08rem);
}
.figure {
    width: 100%;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
    font-weight: 600;
    font-size: 0.3rem;
}
.agreement {
    color: #999;
    font-size: 0.13rem;
    text-align: center;
}
.face_tip {
    font-size: 0.12rem;
    margin-top: 0.4rem;
    text-align: center;
}
.imgbg {
    width: 2.1rem;
    margin: 0 auto;
    padding-top: 0.28rem;
}
.proto_tip {
    margin-top: 0.34rem;
    color: #bcbcbc;
    text-align: center;
}
.btn {
    width: 3.2rem;
    height: 0.49rem;
    color: #fff;
    background: #4181ff;
    border-radius: 5px;
    text-align: center;
    line-height: 0.49rem;
    font-size: 0.15rem;
    margin: 0.18rem auto;
}
.nouse {
    background: #b6b6b6;
}
.button {
    display: inline-block;
    width: 100%;
    height: 100%;
}
.popup {
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: block;
    background-color: rgba(0, 0, 0, 0.75);
    left: 0;
    top: 0;
    text-align: center;
    color: #fff;
}
.tip_pop {
    display: inline-block;
    vertical-align: middle;
    height: 100vh;
}
.text_tip {
    display: inline-block;
    vertical-align: middle;
}
</style>
